<article class="formEditor">
    <span class="formLabel">{{ labelText() }}</span>
    <lib-generic-dropdown
        [source]="items()"
        [selectedItem]="selectedItem()"
        (selectedItemChange)="onSelectedItemChange($event)"
        [config]="{
            defaultText: placeholderText(),
            itemDisplayKey: 'name'
        }"
        [isReadOnly]="isReadOnly()"
    >
    </lib-generic-dropdown>
</article>
